$(function () {

    $('.search-association').each(function () {
        let $this = $(this),
            $searchbox = $("input", $this),
            $searchicon = $(".fa-search", $this);

        let search = function (query) {

            var searchText = $searchbox.val();

            return new Promise(async (resolve, reject) => {
                if (!query) resolve([]);
                let items = await window.fsSearch.searchAssociation(query);
                resolve(items.rawResults);
            });
            
        }

        $this.addClass("typeahead-container");

        $searchbox
            .addClass("typeahead-input")
            .typeahead({
                textproperty: "name.raw",
                source: search
            });

        $searchicon.click(() => { $searchbox.focus() });
    })
});